import {apsEnums} from "../../shared/dto/aps.enums";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import * as _ from "lodash";
import {DefectType} from "../defectType";
import JobRunActivity from "./jobRunActivity";

export default class DefectActivity {
  toolNumber: number;
  dropName: string;
  locationX: number;
  locationY: number;
  gobName: string;
  createdByFullName: string;
  createdOn: Date;
  isDefect: boolean;
  severityName: string;
  defectType: DefectType;
  jobRun: JobRunActivity;
  severityClass: string;
  id: string;
  isMachineId: string;
  section: number;
  gob: number;
  abbreviation: string;
  name: string;
  nameAndLocation: string;
  severity: apsEnums.Severity;
  isMoldRejectInUse: boolean;
  rejectStart: Date;
  rejectEnd: Date;
  isEquipmentFailure: boolean;
  maintenanceStart: Date;
  maintenanceEnd: Date;
  timeFound: Date;
  frequencyType: apsEnums.FrequencyType;
  frequencyCount: number;
  frequencyTotal: number;
  frequencyPercent: number;
  equipmentId: string;
  defectTypeId: string;
  defectTypeLegacyId: number;
  comments: apsViewModels.DefectDetailsComment[];
  hasOpenMoldReject: boolean;
  maintenanceResolution: string;
  resolvedBy: string;
  resolutionTime: Date;
  isFoodCertifiable: boolean;   
  heldPallets: apsViewModels.DefectDetailsHeldPallet[];
  moldLossEquipment:apsEnums.EquipmentType;
  private userProfileData: apsViewModels.UserProfileData;

  constructor(data: apsViewModels.DefectActivity,
              userProfileData: apsViewModels.UserProfileData,
              defectTypes: DefectType[]) {
    _.assign(this, data);

    this.isDefect = true;
    this.severityName = apsEnums.Severity[this.severity];
    this.severityClass = 'severity-' + this.severity;
    this.defectType = _.find(defectTypes, {id: this.defectTypeId});
    this.hasOpenMoldReject = this.isMoldRejectInUse && !this.rejectEnd;
    this.userProfileData = userProfileData;
    this.heldPallets = this.heldPallets || [];
  }

  idAbbr(): string {
    if (!this.defectType) {
      return undefined;
    }

    if (this.userProfileData
      && this.userProfileData.displayDefectsByNumber
      && this.defectType.legacyId) {
      return this.defectType.legacyId.toString();
    } else {
      return this.defectType.abbreviation;
    }
  }

  isFrequencyCount(): boolean {
    return this.frequencyType === apsEnums.FrequencyType.Count;
  }

  isFrequencyPercentage(): boolean {
    return this.frequencyType === apsEnums.FrequencyType.Percentage;
  }

  isFrequencyPSI(): boolean {
    return this.frequencyType === apsEnums.FrequencyType.PSI;
  }

  isFrequencyThermal(): boolean {
    return this.frequencyType === apsEnums.FrequencyType.ThermalShock;
  }
  setEquipFailure(data: {maintenanceStart: Date, maintenanceEnd: Date}) {
    this.maintenanceStart = data.maintenanceStart;
    this.maintenanceEnd = data.maintenanceEnd;
  }

  setMoldReject(data: {isMoldRejectInUse: boolean, rejectStart: Date, rejectEnd: Date}) {
    this.isMoldRejectInUse = data.isMoldRejectInUse;
    this.rejectStart = data.rejectStart;
    this.rejectEnd = data.rejectEnd;
    this.hasOpenMoldReject = this.isMoldRejectInUse && !this.rejectEnd;
  }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/models/activity/defectActivity.ts